export const VESSEL_NAME_UUID = "a5f73383-b6b7-4f85-ac28-885d91329cc4";
export const VESSEL_IMO_UUID = "d43c9823-301b-4e66-b01d-4a0306508f9d";
export const VESSEL_CATEGORY_UUID = "28ea9e91-8329-4630-938a-1f57f8ad352e";
